export default {"src":"/_next/static/media/PTCT.6a0d3550.svg","height":18,"width":18};